import React from 'react';
import { useCountdown } from '../hooks/useCountdown';

/**
 * Prominent inline urgency block shown right below the add-to-cart button.
 */
export function OfferCountdown() {
  const {
    label
  } = useCountdown(600);
  const [minutes, seconds] = label.split(':');
  return <div className="rounded-2xl border border-gold/40 bg-forest/60 px-4 py-5 text-center" data-id="element-64" data-mp="24z6ejsd7cv54">
      <p className="font-display text-[20px] font-bold leading-tight text-gold-bright" data-id="element-65" data-mp="2908e6ab1797m">
        ⚡ OFERTA SOLO POR HOY!
      </p>

      <div className="mt-4 flex items-center justify-center gap-2" data-id="element-66" data-mp="1h6ps75mfmh00">
        {[{
        value: minutes,
        label: 'MIN'
      }, {
        value: seconds,
        label: 'SEG'
      }].map((unit, i) => <React.Fragment key={unit.label} data-id="element-67" data-mp="1q8fkedo51jyu" data-mpi={i}>
            {i > 0 && <span aria-hidden="true" className="font-display text-[34px] font-bold text-gold-bright/60" data-id="element-68" data-mp="1q5jnmso111bz">
                :
              </span>}
            <div className="min-w-[74px] rounded-xl border border-gold/40 bg-night px-3 py-2" data-id="element-69" data-mp="26pt6xluywisv">
              <p className="font-display text-[38px] leading-none font-bold tabular-nums text-gold-bright" data-id="element-70" data-mp="26ngprax1acgv">
                {unit.value}
              </p>
              <p className="mt-1 font-sans text-[11px] font-semibold tracking-[0.18em] text-ivory/45" data-id="element-71" data-mp="1wqc2f7rgcayh">
                {unit.label}
              </p>
            </div>
          </React.Fragment>)}
      </div>

      <p className="mt-4 font-sans text-[13px] leading-relaxed text-ivory/70" data-id="element-72" data-mp="1ns9vycoy8q3t">
        Reserva válida por 10 minutos. Si no accedés, tu descuento pasa a la
        siguiente persona.
      </p>
    </div>;
}